export const useUrlParams = (requiredFields = []) => {
  const params = ref(null)
  const isValid = ref(false)

  const parseParams = () => {
    // SSR 兼容性檢查
    if (!import.meta.client) {
      return null
    }

    try {
      const urlParams = new URLSearchParams(window.location.search)
      const result = {}

      // 提取所有參數
      for (const [key, value] of urlParams.entries()) {
        result[key] = value
      }

      // 驗證必填欄位
      const hasAllRequired = requiredFields.every((field) => result[field])

      if (!hasAllRequired) {
        return null
      }

      return result
    } catch (error) {
      console.error('Failed to parse URL parameters:', error)
      return null
    }
  }

  // 只在 client 端解析一次
  onMounted(() => {
    const result = parseParams()
    params.value = result
    isValid.value = !!result
  })

  return {
    params: readonly(params), // 返回只讀，避免意外修改
    isValid: readonly(isValid),
  }
}
